export enum TICKETS_TABLE_COLUMNS {
    CREATED_AT = 'CreatedAt',
    NOTE = 'Note',
    TECHNICIAN_FIRST_NAME = 'TechnicianFirstName',
    TECHNICIAN_LAST_NAME = 'TechnicianLastName',
    USER_FIRST_NAME = 'UserFirstName',
    USER_LAST_NAME = 'UserLastName',
    FLAG_CLOSED = 'FlagClosed',
    CLOSING_DATE = 'ClosingDate',
    SITE_NAME = 'SiteName',
    TOTAL_ACCESS_EXP_DATE = 'TotalAccessExpDate',
    GRANT_ACCESS = 'grantAccess',
    ACTIONS = 'actions',
}

export const TICKETS_DEFAULT_SORT_COLUMN = TICKETS_TABLE_COLUMNS.CREATED_AT;
export const TICKETS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const TICKETS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const TICKETS_PAGE_DEFAULT_SIZE = 10;

export const TICKETS_NEW_DEFAULT_EXPIRY_DAYS = 7;

export const TICKETS_TABLE_HEADER = [
    TICKETS_TABLE_COLUMNS.CREATED_AT,
    TICKETS_TABLE_COLUMNS.NOTE,
    TICKETS_TABLE_COLUMNS.TECHNICIAN_FIRST_NAME,
    TICKETS_TABLE_COLUMNS.TECHNICIAN_LAST_NAME,
    TICKETS_TABLE_COLUMNS.FLAG_CLOSED,
    TICKETS_TABLE_COLUMNS.CLOSING_DATE,
    TICKETS_TABLE_COLUMNS.SITE_NAME,
    TICKETS_TABLE_COLUMNS.TOTAL_ACCESS_EXP_DATE,
    TICKETS_TABLE_COLUMNS.ACTIONS,
];

export const TICKETS_TECHNICIAN_TABLE_HEADER = [
    TICKETS_TABLE_COLUMNS.CREATED_AT,
    TICKETS_TABLE_COLUMNS.NOTE,
    TICKETS_TABLE_COLUMNS.USER_FIRST_NAME,
    TICKETS_TABLE_COLUMNS.USER_LAST_NAME,
    TICKETS_TABLE_COLUMNS.FLAG_CLOSED,
    TICKETS_TABLE_COLUMNS.CLOSING_DATE,
    TICKETS_TABLE_COLUMNS.SITE_NAME,
    TICKETS_TABLE_COLUMNS.TOTAL_ACCESS_EXP_DATE,
    TICKETS_TABLE_COLUMNS.GRANT_ACCESS,
    TICKETS_TABLE_COLUMNS.ACTIONS,
];
